/*
-------------------------------------------------------------------------
IMPORTANT!!!!  IMPORTANT!!!!  IMPORTANT!!!!  IMPORTANT!!!!  IMPORTANT!!!!
-------------------------------------------------------------------------

-------------------------------------------------------------------------
Android App not connecting to internet:
  ref:  https://forum.ionicframework.com/t/ionic-run-android-works-but-apk-does-not-access-internet/3867/30

-------------------------------------------------------------------------
Android Version issues between GooglePlayServices:
  ref:  https://forum.ionicframework.com/t/ionic-v4-push-plugin-build-issues-with-android/160822/3
  ref:  https://github.com/dpa99c/cordova-android-play-services-gradle-release

  need to run this command:
  cordova plugin add cordova-android-play-services-gradle-release --variable PLAY_SERVICES_VERSION=16+

-------------------------------------------------------------------------

// TEST GITHUB

-------------------------------------------------------------------------
IMPORTANT!!!!  IMPORTANT!!!!  IMPORTANT!!!!  IMPORTANT!!!!  IMPORTANT!!!!
-------------------------------------------------------------------------
*/


import { CommonService } from 'src/app/services/common/common.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { Component } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import {TranslateService} from '@ngx-translate/core';

// ADDED MANUALLY BY ME -- for theme test
//import * as Parse from 'parse'; // 'parse';
//import { environment } from '../environments/environment';

// add global variables here
import * as Constants from 'src/app/services/constants/constants';

// ADDED MANUALLY BY ME
//import { ViewChild } from '@angular/core';
import { MenuController } from '@ionic/angular';
import { AlertController } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { NgZone  } from '@angular/core'; // ref: https://stackoverflow.com/questions/45866379/ionic-3-hide-ion-footer-on-login-page
import { Router } from '@angular/router';

// import { Events } from '@ionic/angular';  // deprecated in Ionic 5
import { Events } from 'src/app/services/events/events.service';  // workaround for events

// SERVICES / PROVIDERS
import { RuntimeService } from 'src/app/services/runtime/runtime.service';
//FIREBASE-YO: import { PushfirebaseService } from 'src/app/services/pushfirebase/pushfirebase.service';
import { PushphonegapService } from 'src/app/services/pushphonegap/pushphonegap.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { GeolocationWrapperService } from 'src/app/services/geolocation/geolocation.service';
import { DocumentService } from 'src/app/services/document/document.service';
// import { Title } from '@angular/platform-browser';

import { NotificationData } from 'src/app/services/global/structure';

// PAGES
// import { ActionsPage } from './pages/actions/actions.page';

// MODAL PAGES
import { AttentionSurveyModalPage } from './pages/attention-survey-modal/attention-survey-modal.page';
import { AttentionActionableModalPage } from './pages/attention-actionable-modal/attention-actionable-modal.page';
import { from } from 'rxjs';
import { Deeplinks } from '@ionic-native/deeplinks/ngx';
//import { ApiService } from 'src/app/services/api/api.service';
// import { MyfooterComponent } from './components/myfooter/myfooter.component';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent 
{
  //@ViewChild(Nav) nav: Nav;

  public pageName:string = "app.component";

  //rootPage = ActionsPage; 
  //rootPage = SplashPage;  // this will determine whether to go to login or default page (e.g. ActionsPage)
  // NOTE: we could make default page configurable in the app settings page....

  // NOTE -- do NOT change the INDX number as this is used for the PageStatus!!
  // NOTE -- do NOT change the INDX number as this is used for the PageStatus!!
  // NOTE -- do NOT change the INDX number as this is used for the PageStatus!!
  // NOTE -- do NOT change the INDX number as this is used for the PageStatus!!
  public appPages = 
   [ { id:  1, indx:  0, display: 'top'   ,  category: 1, divider: true , active: true, requiresSystemAccess: false,  title: 'INITIATE'     , url: ''                       , icon: ''                 , component: null           , pageStatus:''  , badgecolor:'mymenudivider' }
   , { id:  2, indx:  1, display: 'top'   ,  category: 1, divider: false, active: true, requiresSystemAccess: false,  title: 'Actions'      , url: '/actions'               , icon: 'flash'            , component: null    , pageStatus:''  , badgecolor:'mymenudivider'  }
   
   , { id:  3, indx:  2, display: 'top'   ,  category: 1, divider: true , active: true, requiresSystemAccess: false,  title: 'RESPOND'      , url: ''                       , icon: ''                 , component: null           , pageStatus:''  , badgecolor:'danger'  }
   , { id:  4, indx:  3, display: 'top'   ,  category: 2, divider: false, active: true, requiresSystemAccess: false,  title: 'Attention'    , url: '/attention'             , icon: 'alert'            , component: null    , pageStatus:''  , badgecolor:'danger'  }
   , { id:  5, indx:  4, display: 'top'   ,  category: 2, divider: false, active: true, requiresSystemAccess: false,  title: 'Assigned'     , url: '/assigned'              , icon: 'flag'             , component: null    , pageStatus:''  , badgecolor:'danger'  }
   , { id:  6, indx:  5, display: 'top'   ,  category: 3, divider: false, active: true, requiresSystemAccess: false,  title: 'Messages'     , url: '/ambitmessage'          , icon: 'mail'             , component: null    , pageStatus:''  , badgecolor:'danger'  }
   , { id:  7, indx:  6, display: 'top'   ,  category: 3, divider: false, active: false,requiresSystemAccess: false,  title: 'Chat Log'     , url: '/chatlog'               , icon: 'ios-chatbubbles'  , component: null    , pageStatus:''  , badgecolor:'danger'  }
   
   , { id:  8, indx:  7, display: 'top'   ,  category: 3, divider: true , active: true, requiresSystemAccess: false,  title: 'ACTIVITY'     , url: ''                       , icon: ''                 , component: null           , pageStatus:''  , badgecolor:'warning'  }
   , { id:  9, indx:  8, display: 'top'   ,  category: 3, divider: false, active: true, requiresSystemAccess: false,  title: 'Submitted'    , url: '/submitted'             , icon: 'send'             , component: null    , pageStatus:''  , badgecolor:'warning'  }
   , { id: 10, indx:  9, display: 'top'   ,  category: 3, divider: false, active: true, requiresSystemAccess: true,   title: 'Broadcasted'  , url: '/broadcasted'           , icon: 'megaphone'        , component: null    , pageStatus:''  , badgecolor:'warning'  }
   , { id: 11, indx: 10, display: 'top'   ,  category: 3, divider: false, active: true, requiresSystemAccess: false,  title: 'Notifications', url: '/eventnotification'     , icon: 'information-circle-outline', component: null    , pageStatus:''  , badgecolor:'warning'  }
   
   , { id: 11, indx: 11, display: 'top'   ,  category: 5, divider: true , active: true, requiresSystemAccess: false,  title: 'GENERAL'      , url: ''                       , icon: ''                 , component: null           , pageStatus:''  , badgecolor:'mymenudivider'  }
   , { id: 12, indx: 12, display: 'bottom',  category: 5, divider: false, active: true, requiresSystemAccess: false,  title: 'Map'          , url: '/map'                   , icon: 'locate'           , component: null    , pageStatus:''  , badgecolor:'mymenudivider'  }
   , { id: 13, indx: 13, display: 'bottom',  category: 5, divider: false, active: true, requiresSystemAccess: false,  title: 'Settings'     , url: '/settings'              , icon: 'settings'         , component: null    , pageStatus:''  , badgecolor:'mymenudivider'  }
   , { id: 14, indx: 14, display: 'bottom',  category: 5, divider: false, active: true, requiresSystemAccess: false,  title: 'Account'      , url: '/useraccount'           , icon: 'person'           , component: null    , pageStatus:''  , badgecolor:'mymenudivider'  }
   
   , { id: 90, indx: 15, display: 'bottom',  category: 9, divider: true , active: false, requiresSystemAccess: false,  title: 'TEST'        , url: ''                       , icon: ''                 , component: null           , pageStatus:''  , badgecolor:'mymenudivider'  }
   , { id: 93, indx: 16, display: 'bottom',  category: 9, divider: false, active: false, requiresSystemAccess: false,  title: 'Theme'       , url: '/test-theme'            , icon: 'color-palette'    , component: null    , pageStatus:''  , badgecolor:'mymenudivider'  }
   , { id: 13, indx: 17, display: 'bottom',  category: 5, divider: false, active: false, requiresSystemAccess: false,  title: 'Logout'      , url: '/login'                 , icon: 'log-out'          , component: null    , pageStatus:''  , badgecolor:'mymenudivider'  }
   , { id: 94, indx: 18, display: 'bottom',  category: 9, divider: false, active: false, requiresSystemAccess: false,  title: 'LifeCycle'   , url: '/test-lifecycle'        , icon: 'refresh-circle'   , component: null    , pageStatus:''  , badgecolor:'mymenudivider'  }
   , { id: 91, indx: 19, display: 'bottom',  category: 9, divider: false, active: false, requiresSystemAccess: false,  title: 'Home'        , url: '/home'                  , icon: 'home'             , component: null    , pageStatus:''  , badgecolor:'mymenudivider'  }
   , { id: 92, indx: 20, display: 'bottom',  category: 9, divider: false, active: false, requiresSystemAccess: false,  title: 'List'        , url: '/list'                  , icon: 'list'             , component: null    , pageStatus:''  , badgecolor:'mymenudivider'  }
  ];
  // NOTE -- do NOT change the INDX number as this is used for the PageStatus!!
  // NOTE -- do NOT change the INDX number as this is used for the PageStatus!!
  // NOTE -- do NOT change the INDX number as this is used for the PageStatus!!
  // NOTE -- do NOT change the INDX number as this is used for the PageStatus!!


  menuPageResponseRequired:number = 0;

  public InsiteLogo:any = '';
  public InternalVersionNumber:string = "";
  public StartupDebugInfo:string = "";
  public runtimeDetails:string = "(NO RUNTIME DETAILS)";
  public deviceDetails:string = "(NO DEVICE DETAILS)";
  public AndroidVersionCode:number = 0; 
  public PanicModeConfig:string = "";
  
  public SystemClientAccessFlag:boolean = false;
  public HealthRiskFlag:boolean = false;
  public MobileUserDisplayName:string = "";
  public UserStatus:string = "";
  public SiteCode:string = "";
  public SiteName:string = "";
  public DepartmentCode:string = "";
  public DepartmentName:string = "";
  public OrganizationCode:string = "";
  public OrganizationName:string = "";
  public SurveyBroadcastLicensedFlag:boolean = false;
  private consoleLog:boolean = false;
  private consoleEventCountsLog:boolean = false;
  private consoleSideMenuLog:boolean = false;

  // Subscription: Notification 
  // private notificationSubscription: Subscription;
  private isNotification:boolean = false;
  private NotificationData:NotificationData;
  public SurveyBroadcastId:number = 0;
  public ActionableBroadcastId:number = 0;
  public AmbitMessageId:number = 0;
  //private isMenu:boolean = true;
  
  //public isActiveSubscriptionMenuCounts: boolean = false;
  public isActiveSubscriptionNotification: boolean = false;
  
  constructor
    ( private platform: Platform
    , private splashScreen: SplashScreen
    , private statusBar: StatusBar
    , public translate: TranslateService
    , public zone: NgZone 
    , public events: Events
    , public menu: MenuController
    , private alertController: AlertController
    , private modalController: ModalController
    , private runtime: RuntimeService

    , private router: Router   // instead of navigator
  
    // MY SERVICE PROVIDERS: -- DO WE NEED ALL OF THESE ????
    //, private pagenav: PagenavProvider
    , public globalProvider:GlobalService
    , private commonProvider:CommonService
    //, private connectivityProvider: ConnectivityService
    , private notificationProvider: NotificationService
    //, private monitoringProvider: MonitoringService
    , private geolocationProvider: GeolocationWrapperService
    //, public apiProvider: ApiService  
    //FIREBASE-YO: , private pushfirebase: PushfirebaseService
    , private pushphonegap: PushphonegapService  
    , public documentService: DocumentService
    , private deeplinks: Deeplinks
    )
  {
    console.log('app.ctor - LifeCycle'); // android:versionCode="1961330"
    this.initializeApp();
  }

  async initializeApp() 
  {
    //if (this.consoleLog) 
    // console.log('app.initializeApp - awaiting ready...');
    await this.platform.ready();

    this.platform.ready().then(() => 
    {
      this.consoleLog = this.globalProvider.consoleLog_appcomponent;
      if (this.consoleLog) console.log('app.initializeApp - ready!');
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.setupDeeplinks();

      this.AppPlatformIsReady(); // my code really starts here
    });
  }

  setupDeeplinks() {
    this.deeplinks.route({
      '/app/login': 'login'
    , '/app/sso': 'sso'
    , '/app/redirect': 'redirect'
    }).subscribe(
      match => {
        console.log('app.setupDeeplinks: Successfully matched route', match);
        const internalPath = `/${match.$route}?${match.$link.queryString}`;
        this.zone.run(() => {
          this.router.navigateByUrl(internalPath);
        });
      },
      nomatch => {
        console.error("app.setupDeeplinks: Got a deeplink that didn't match", nomatch);
      }
    );
  }

  AppPlatformIsReady()
  {
    if (this.consoleLog) console.log('app.InitializeOnceReady');

    this.PrimeDataFromStorage().then( val => 
    {
      if (this.consoleLog) console.log('app.InitializeOnceReady: after storage prime');
      this.StartupDebugInfo = this.runtime.GetRuntimeName(); //CommonCode.GetStartupDebugInfo();
      this.runtimeDetails = this.runtime.GetEnvironmentDetails(true);
      this.deviceDetails = this.runtime.GetDeviceDetails();
      this.AndroidVersionCode = this.runtime.GetApkAndroidVersionCode();
      this.PanicModeConfig = this.globalProvider.GetPanicModeConfigInfo();
      this.GetRuntime(); 
      this.setupInitialTranslation();
      this.setupListeners();
      this.subscriptions(true, "AppPlatformIsReady");

      // call the mobile dashboard once to setup the counts
      this.CallGetDashboardStatusForMobile("AppPlatformIsReady", false);

      // TESTING ONLY!!
      // this.notificationProvider.TriggerNotificationTest("app.component", 8, 16347);
      // this.notificationProvider.TriggerNotificationTest("app.component", 22, 16193);
    });
  }

  public PrimeDataFromStorage(): Promise<boolean> //public CheckActiveLogin(): Promise<boolean>
  {
    if (this.consoleLog) console.log("app.PrimeDataFromStorage");

    // not expecting any data to exist in memory when the app starts up
    // but check just in case (useful if we are testing with hard-coded memory data too)
    if (this.globalProvider.VerifyActiveLoginFromTransientMemory())
    {
      if (this.consoleLog) console.log('app.PrimeDataFromStorage: exists ok');
      return Promise.resolve(true);
    }

    // otherwise see if there is any data in storage that we can use to avoid user login
    //return this.globalProvider.PrimeDataFromStorage_MobileUserProfile(); 
    return this.globalProvider.PrimeDataFromStorage();  // get all the user preferred settings etc.
  }

  GetRuntime()
  {
    if (this.consoleLog) console.log('app.GetRuntime ' + this.runtime.GetRuntimeName());
  }

  setupInitialTranslation()
  {
    //if (this.consoleLog) 
    console.log('app.setupInitialTranslation');

    // NOTE: these are just the basic asset local files and NOT the API language data
    //       Use these local files to bootstrap the displayed language (e.g. for login)
    //       and then immediately replace with the correct server-based language
    this.translate.addLangs(['en', 'fr']);   // ToDo:  add more of the basic languages offered here
    this.translate.setDefaultLang('en');     
    this.translate.use('en');

    this.documentService.setReadingDirection('ltr');  // set default language direction...
  }

  setupListeners()
  {
    if (this.consoleLog) console.log('app.setupListeners');
    
    this.InitializePlatformListeners("[app-component]");
    //this.connectivityProvider.addListeners("[app-component]");   // starts NETWORK LISTEN process
    //FIREBASE-YO: this.pushfirebase.InitializeProvider("[app-component]");
    this.geolocationProvider.callInitializers("[app-component]");    // setup Location but don't start yet 
    //this.notificationProvider.initPush("[app-component]");  
  }

  InitializePlatformListeners(context:string)
  {
    if (this.consoleLog) console.log('app.InitializePlatformListeners');
    this.platform.backButton.subscribe(()=>{this.appBackButton();});
    this.platform.pause.subscribe(()=>{this.appPause();});
    this.platform.resume.subscribe(()=>{this.appResume();});
  }
  appBackButton()
  {
    console.log('app.appBackButton');
  }
  appPause()
  {
    console.log('app.appPause');
    if (this.globalProvider.MobileUserProfile.ActiveLogin)
    {
        // do something only if user logged in -- if anything
    }
  }
  appResume()
  {
    console.log('app.appResume');
    if (this.globalProvider.MobileUserProfile.ActiveLogin)
    {
      // refresh location position, get dashboard (which will trigger any unseen survey)
      this.geolocationProvider.GetGpsLocationOneTime(false);

      // let's avoid the call to Dashboard in order to try and avoid the multiple Actionable Modals appearing
      // - instead, let the main Action page update this 
      this.CallGetDashboardStatusForMobile("appResume", false); // CallGetSurveyLatestByMobileUser();
    }
    else
    {
      console.log('app.appResume: NOT logged in');
    }
  }

  // ----------------------------------------------------
  // --------   CHECK APP MODE RESTRICTIONS  ------------
  // ----------------------------------------------------

  CheckAppPanicModeOnly():boolean
  {
    if (this.consoleLog) console.log("app.CheckAppPanicModeOnly");
    return this.globalProvider.CheckAppPanicMode("app.component");
  }

  // ----------------------------------------------------
  // ------------   SIDE MENU NAVIGATE     --------------
  // ----------------------------------------------------

  public openPage(id:number, title:string, url:string) 
  {
    console.log('app.openPage: ' + title + ' - LifeCycle');

    if (url === '/login')
    {
      // we are logging out, so time to clean up
      this.AlertLogout(url);
      return;
    }

    if (this.CheckAppPanicModeOnly())
    {
      if (url !== '/actions-monitor')
      {
        console.warn('app.openPage: OVERRIDE from ' + title + ' to PANIC PAGE ');
        this.globalProvider.isPanicDisplayFromLogin = true; 
      }
      url = '/actions-monitor';  // actions-panic
    }
    else
    {
      console.log('app.openPage: not panic mode app (FYI)');
      /*
      if (url === '/actions-panic') // cannot go here unless in panic mode (for now)
      {
        console.warn('app.component.openPage: OVERRIDE from PANIC PAGE to ACTIONS');
        url = '/actions';
      }
      */
    }
    
    //let url = this.appPages[0].url;
    //this.router.navigateByUrl(url, { skipLocationChange: true });
    this.router.navigateByUrl(url);    //this.nav.setRoot(page.component);
  }

  async AlertLogout(url:string) 
  {
    if (this.consoleLog) console.log("app.AlertLogout - " + url);

    const alert = await this.alertController.create(
      { header: this.myTranslate('Logout')
      , subHeader: this.myTranslate('Are you sure you want to logout?')
      , message: this.myTranslate('Cancel to remain logged in')
      , buttons: [
        { text: this.myTranslate('Cancel')
        , handler: () => 
          { 
            console.log('app.AlertLogout: Cancel Logout clicked'); 
          }
        }
        ,
        { text: this.myTranslate('Confirm Logout')
        //, role: 'cancel'
        , handler: () => 
          { 
            console.log('app.AlertLogout: Confirm Logout clicked'); 
            this.globalProvider.ClearGlobalAndStorage("app.VerifyLogout - " + url);
            this.router.navigateByUrl(url); 
          }
        }
      ]
    });
    await alert.present(); 
  }

  
  menuWillOpen()
  {
    if ((this.consoleLog) || (this.consoleSideMenuLog)) console.log('app.menuWillOpen');
    this.zone.run(() => {
      this.SetSideMenuValues("menuWillOpen");
      this.PanicModeConfig = this.globalProvider.GetPanicModeConfigInfo();
    });
  }

  menuDidOpen()
  {
    if ((this.consoleLog) || (this.consoleSideMenuLog)) console.log('app.menuDidOpen');
    this.zone.run(() => {
      this.SetSideMenuValues("menuDidOpen");
    });
  }

  menuWillClose()
  {
    if ((this.consoleLog) || (this.consoleSideMenuLog)) console.log('app.menuWillClose');
    this.zone.run(() => {
      this.SetSideMenuValues("menuWillClose");
    });
  }

  menuDidClose()
  {
    if ((this.consoleLog) || (this.consoleSideMenuLog)) console.log('app.menuDidClose');
    this.VerifyPushRegistration();
  }

  SetSideMenuValues(context:string)
  {
    if ((this.consoleLog) || (this.consoleSideMenuLog)) console.log('app.SetSideMenuValues ' + context);
    this.SetSideMenuCounts(context);
    this.SetSideMenuProfile(context);
    this.SetSideMenuConfig(context);
  }

  // ----------------------------------------------------
  // ---------------      SUBSCRIPTIONS       -----------
  // ----------------------------------------------------
  subscriptions(isSubscribe:boolean, context:string)
  {
    if (this.consoleLog) console.log('app.Subscriptions: ' + (isSubscribe ? "SUBSCRIBE" : "UNSUBSCRIBE") + ' - ' + this.pageName + " " + context);
    
    this.SubscribeToNotification(isSubscribe, context);
    //this.SubscribeToMenuCounts(isSubscribe, context);
  }


  // ----------------------------------------------------
  // ----------    MENU EVENT COUNTS  WATCH   -----------
  // ----------------------------------------------------
// https://forum.ionicframework.com/t/events-pub-sub-how-to-unsubscribe-in-lifecycle-hook/50596/5?u=xme
  /*
  private _MenuCountsApiEventSub: (data:any) => void;
  DefineMenuCountsApiEventSub()
  {
    // NOTE!  remember to call this just before subscribing to the event
    if (this.consoleLog) console.log("app.DefineMenuCountsApiEventSub" + " Active:" + this.isActiveSubscriptionMenuCounts);
    this._MenuCountsApiEventSub = (data:any) => {
      if (this.consoleLog) console.log("app.MenuCountsApiEventSub " + " Active:" + this.isActiveSubscriptionMenuCounts + " - data:", data);      this.onMobileEventCounts(data);
    };
  }

  //public isActiveSubscriptionMenuCounts: boolean = false;
  SubscribeToMenuCounts(isSubscribe:boolean, context:string)
  {
    if (this.consoleLog) console.log("app.SubscribeToMenuCounts SUBSCRIBE:" + isSubscribe + " - " + context + " Active:" + this.isActiveSubscriptionMenuCounts);

    if (isSubscribe)
    {
      if (this.isActiveSubscriptionMenuCounts === true)
      {
        if (this.events.consoleLog) console.log("app.SubscribeToMenuCounts - isMobileEventCounts - ALREADY ACTIVE");
        return;
      }
      this.isActiveSubscriptionMenuCounts = true;
      this.DefineMenuCountsApiEventSub();
      if (this.events.consoleLog) console.log("app.SubscribeToMenuCounts - isMobileEventCounts - ADD");
      this.events.subscribe(this.pageName, 'isMobileEventCounts', this._MenuCountsApiEventSub);
    }
    else
    {
      if (this.events.consoleLog) console.log("app.SubscribeToMenuCounts - isMobileEventCounts - REMOVE");
      this.events.unsubscribe(this.pageName, 'isMobileEventCounts', this._MenuCountsApiEventSub);
      this.isActiveSubscriptionMenuCounts = false;
    }
  }

  onMobileEventCounts(data:any)
  {
    if ((this.consoleLog) || (this.consoleSideMenuLog)) console.log("app.onMobileEventCounts", data);
    this.zone.run(() => {
      //this.myMenuBadgeCount = this.globalProvider.MobileEventCounts.ResponseRequiredTotal.Total;
      //this.SetMenuBadgeCount("app.component.onMobileEventCounts");
      this.SetSideMenuValues("app.onMobileEventCounts"); // get initial/latest state
    });
  }
  */

  // ----------------------------------------------------
  // ------------      SIDE MENU COUNTS     --------------
  // ----------------------------------------------------

  SetMenuBadgeCount(context:string)
  {
    if ((this.consoleLog) || (this.consoleSideMenuLog)) console.log('app.SetMenuBadgeCount - ' + context);
    if ((this.globalProvider) && (this.globalProvider.MobileEventCounts))
    {
      // badge menu count visible on all page headers
      if (this.globalProvider.MobileEventCounts.ResponseRequiredTotal)
      {
        this.menuPageResponseRequired = 
        this.globalProvider.MobileEventCounts.ResponseRequiredTotal.Total;
      }
    }
    else
    {
      console.warn('app.component.SetMenuBadgeCount - missing counts - ' + context);
    }
  }

  SetSideMenuCounts(context:string)
  {
    if ((this.consoleLog) || (this.consoleSideMenuLog)) console.log('app.SetSideMenuCounts - ' + context);
    if ((this.globalProvider) && (this.globalProvider.MobileEventCounts))
    {
      // badge menu count visible on all page headers
      this.SetMenuBadgeCount(context);

      /*  FYI  use the INDX field to set the pageStatus!
      public appPages = 
      , { id:  3, indx:  2, display: 'top'   ,  category: 1, divider: true , active: true,  title: 'RESPOND'      , url: ''                       , icon: ''                 , component: null           , pageStatus:''  , badgecolor:'danger'  }
      , { id:  4, indx:  3, display: 'top'   ,  category: 2, divider: false, active: true,  title: 'Attention'    , url: '/attention'             , icon: 'alert'            , component: ActionsPage    , pageStatus:''  , badgecolor:'danger'  }
      , { id:  5, indx:  4, display: 'top'   ,  category: 2, divider: false, active: true,  title: 'Assigned'     , url: '/assigned'              , icon: 'flag'             , component: ActionsPage    , pageStatus:''  , badgecolor:'danger'  }
      , { id:  6, indx:  5, display: 'top'   ,  category: 3, divider: false, active: true,  title: 'Ambit Messages', url: '/ambitmessage'         , icon: 'information-circle-outline', component: ActionsPage    , pageStatus:''  , badgecolor:'warning'  }
      , { id:  7, indx:  6, display: 'top'   ,  category: 3, divider: false, active: false, title: 'Chat Log'     , url: '/chatlog'               , icon: 'ios-chatbubbles'  , component: ActionsPage    , pageStatus:''  , badgecolor:'warning'  }
      
      , { id:  8, indx:  7, display: 'top'   ,  category: 3, divider: true , active: true,  title: 'ACTIVITY'     , url: ''                       , icon: ''                 , component: null           , pageStatus:''  , badgecolor:'mymenudivider'  }
      , { id:  9, indx:  8, display: 'top'   ,  category: 3, divider: false, active: true,  title: 'Submitted'    , url: '/submitted'             , icon: 'send'             , component: ActionsPage    , pageStatus:''  , badgecolor:'warning'  }
      , { id: 10, indx:  9, display: 'top'   ,  category: 3, divider: false, active: true,  title: 'Broadcasted'  , url: '/broadcasted'           , icon: 'megaphone'        , component: ActionsPage    , pageStatus:''  , badgecolor:'warning'  }
      , { id: 11, indx: 10, display: 'top'   ,  category: 3, divider: false, active: true,  title: 'Notifications', url: '/eventnotification'     , icon: 'information-circle-outline', component: ActionsPage    , pageStatus:''  , badgecolor:'warning'  }
      
      */

      // badge counts visible within side menu only
      // ATTENTION indx=3

      if ((this.consoleLog) && (this.consoleEventCountsLog))
      { 
        if (this.globalProvider.MobileEventCounts)
        {
          console.log("SetSideMenuCounts Attention.Total:" + this.globalProvider.MobileEventCounts.Attention.Total, this.globalProvider.MobileEventCounts.Attention);
          console.log("SetSideMenuCounts Assigned.Total:" + this.globalProvider.MobileEventCounts.Assigned.Total, this.globalProvider.MobileEventCounts.Assigned);
          console.log("SetSideMenuCounts AmbitMessage.Total:" + this.globalProvider.MobileEventCounts.AmbitMessage.Total, this.globalProvider.MobileEventCounts.AmbitMessage);
          console.log("SetSideMenuCounts Submitted.Total:" + this.globalProvider.MobileEventCounts.Submitted.Total, this.globalProvider.MobileEventCounts.Submitted);
          console.log("SetSideMenuCounts Broadcasted.Total:" + this.globalProvider.MobileEventCounts.Broadcasted.Total, this.globalProvider.MobileEventCounts.Broadcasted);
          console.log("SetSideMenuCounts EventNotification.Total:" + this.globalProvider.MobileEventCounts.EventNotification.Total, this.globalProvider.MobileEventCounts.EventNotification);
        }
      }

      if ((this.globalProvider.MobileEventCounts.Attention) && (this.globalProvider.MobileEventCounts.Attention.Total >=0))
      {
        this.appPages[3].pageStatus = 
        this.globalProvider.MobileEventCounts.Attention.Total.toString();
      }
  
      // ASSIGNED indx=4
      if ((this.globalProvider.MobileEventCounts.Assigned) && (this.globalProvider.MobileEventCounts.Assigned.Total >=0))
      {
        this.appPages[4].pageStatus =  
        this.globalProvider.MobileEventCounts.Assigned.Total.toString();
      }
  
      // AMBIT MESSAGES indx=5
      if ((this.globalProvider.MobileEventCounts.AmbitMessage) && (this.globalProvider.MobileEventCounts.AmbitMessage.Total >=0))
      {
        this.appPages[5].pageStatus =  
        this.globalProvider.MobileEventCounts.AmbitMessage.Total.toString();
      }

      // SUBMITTED indx=8
      if ((this.globalProvider.MobileEventCounts.Submitted) && (this.globalProvider.MobileEventCounts.Submitted.Total >=0))
      {
        this.appPages[8].pageStatus =  
        this.globalProvider.MobileEventCounts.Submitted.Total.toString();
      }
  
      // BROADCASTED indx=9
      if ((this.globalProvider.MobileEventCounts.Broadcasted) && (this.globalProvider.MobileEventCounts.Broadcasted.Total >=0))
      { 
        this.appPages[9].pageStatus =  
        this.globalProvider.MobileEventCounts.Broadcasted.Total.toString();
      }

      // EVENT NOTIFICATION indx=10
      if ((this.globalProvider.MobileEventCounts.EventNotification) && (this.globalProvider.MobileEventCounts.EventNotification.Total >=0))
      {
        this.appPages[10].pageStatus =  
        this.globalProvider.MobileEventCounts.EventNotification.Total.toString();
      }
    }
    else
    {
      console.warn('app.component.SetSideMenuCounts - missing counts - ' + context);
    }
  }

  SetSideMenuProfile(context:string)
  {
    if ((this.consoleLog) || (this.consoleSideMenuLog)) console.log('app.SetSideMenuProfile - ' + context);
    if ((this.globalProvider) && (this.globalProvider.MobileUserProfile))
    {
      if (this.consoleLog) console.log('myfooter.SetSideMenuProfile: ' 
                  + ' HealthRiskFlag BEFORE:' + this.HealthRiskFlag
                  + ' HealthRiskFlag AFTER:' + this.globalProvider.MobileUserProfile.HealthRiskFlag
                  + ' - Page:' + this.pageName + " " + context);

      this.HealthRiskFlag = this.globalProvider.MobileUserProfile.HealthRiskFlag;

      this.MobileUserDisplayName = this.globalProvider.MobileUserProfile.MobileUserDisplayName;
      this.SiteCode = this.globalProvider.MobileUserProfile.SiteCode;
      this.SiteName = this.globalProvider.MobileUserProfile.SiteName;
      this.DepartmentCode = this.globalProvider.MobileUserProfile.DepartmentCode;
      this.DepartmentName = this.globalProvider.MobileUserProfile.DepartmentName;
      this.OrganizationCode = this.globalProvider.MobileUserProfile.OrganizationCode;
      this.OrganizationName = this.globalProvider.MobileUserProfile.OrganizationName;

      this.SystemClientAccessFlag = this.globalProvider.MobileUserProfile.SystemClientAccessFlag;
    }
    else
    {
      console.warn('app.component.SetSideMenuProfile - missing counts - ' + context);
    }
  }

  SetSideMenuConfig(context:string)
  {
    if ((this.consoleLog) || (this.consoleSideMenuLog)) console.log('app.SetSideMenuConfig - ' + context);
    if ((this.globalProvider) && (this.globalProvider.AmbitConfig))
    {
      //this.InsiteLogo = this.globalProvider.AmbitConfig.InsiteLogo; // CommonCode.GetThemeLogo();
      this.InsiteLogo = this.globalProvider.AmbitConfig.GetInsiteLogo();
      this.InternalVersionNumber = this.globalProvider.AmbitConfig.AmbitMobileAppVersion;
      this.SurveyBroadcastLicensedFlag = this.globalProvider.AmbitConfig.SurveyBroadcastLicensedFlag;
    }
    else
    {
      console.warn('app.component.SetSideMenuConfig - missing counts - ' + context);
    }
  }

  // ----------------------------------------------------
  // ---------- NOTIFICATION CONTROLLER WATCH -----------
  // ----------------------------------------------------
  // https://forum.ionicframework.com/t/events-pub-sub-how-to-unsubscribe-in-lifecycle-hook/50596/5?u=xme
  private _NotificationEventSub: (data:any) => void;
  DefineNotificationEventSub()
  {
    // NOTE!  remember to call this just before subscribing to the event
    if (this.consoleLog) console.log("app.DefineNotificationEventSub" + " Active:" + this.isActiveSubscriptionNotification);
    this._NotificationEventSub = (data:any) => {
      if (this.consoleLog) console.log("app.NotificationEventSub " + " Active:" + this.isActiveSubscriptionNotification + " - data:", data);
      this.onNotification(data);
    };
  }

  SubscribeToNotification(isSubscribe:boolean, context:string)
  {
    if (this.consoleLog) console.log("app.SubscribeToNotification SUBSCRIBE:" + isSubscribe + " - " + context + " - Active:" + this.isActiveSubscriptionNotification);

    this.isNotification = this.notificationProvider.IsNotification();  // get initial/latest state
    if (isSubscribe)
    {
      if (this.isActiveSubscriptionNotification === true)
      {
        if (this.events.consoleLog) console.log("app.SubscribeToNotification - isNotification - ALREADY ACTIVE");
        return;
      }
      this.isActiveSubscriptionNotification = true;
      this.DefineNotificationEventSub();
      if (this.events.consoleLog) console.log("app.SubscribeToNotification - isNotification - ADD");
      this.events.subscribe(this.pageName, 'isNotification', this._NotificationEventSub);
    }
    else
    {
      if (this.events.consoleLog) console.log("app.SubscribeToNotification - isNotification - REMOVE");
      this.events.unsubscribe(this.pageName, 'isNotification', this._NotificationEventSub);
      this.isActiveSubscriptionNotification = false;
    }
  }

  onNotification(data:any)
  {
    //if (this.consoleLog) 
    console.log("app.onNotification", data);
    this.zone.run(() => {
      //this.isNotification = data.isNotification;
      this.isNotification = this.notificationProvider.IsNotification();
      this.processNotification(data);
      this.SetMenuBadgeCount("onNotification");
      // just to be sure....
      this.SetSideMenuCounts("onNotification");
      this.SetSideMenuProfile("onNotification");
      this.SetSideMenuConfig("onNotification");
      //// if (this.content) { this.content.resize(); }
    });
  }

  // ----------------------------------------------------
  // ---------- NOTIFICATION ALERT PROCESSING -----------
  // ----------------------------------------------------
  processNotification(data:any)
  {
    if (this.consoleLog) console.log("app.processNotification", data);
    if ((!data) || (!data.NotificationData) || (data.NotificationData.NotificationTypeCode === ""))
    {
      console.error("app.processNotification - missing notification data", data);
      this.commonProvider.presentToastError("Missing notification data", "Programming error");
      return;
    }

    // put the data passed into a strongly typed structure -- then handle accordingly
    this.NotificationData = data.NotificationData;
    console.log('app.processNotification: ' + this.NotificationData.NotificationTypeCode);

    if (this.globalProvider.CheckAppPanicMode("app.processNotifiction"))
    {
      if (this.NotificationData.NotificationTypeCode !== Constants.NOTIFICATION_TYPE_MONITOR)
      {
        console.warn('app.processNotification: ' + this.NotificationData.NotificationTypeCode 
                    + ' when App is limited to Panic mode');
        return;
      }
    }
    
    switch (this.NotificationData.NotificationTypeCode) // .AmbitEventTypeCode
    {
      case Constants.NOTIFICATION_TYPE_ACTIONABLE:
      {
        console.log('app.processNotification: call DisplayNotificationActionableModal');
        this.DisplayNotificationActionableModal(data.NotificationData, this.NotificationData.ActionableBroadcastId, this.NotificationData.NotificationSourceCode, this.NotificationData.NotificationTypeCode);
        break;
      }

      case Constants.NOTIFICATION_TYPE_SURVEY:
      {
        console.log('app.processNotification: call DisplayNotificationSurveyModal');
        this.DisplayNotificationSurveyModal(data.NotificationData, this.NotificationData.SurveyBroadcastId, this.NotificationData.NotificationSourceCode, this.NotificationData.NotificationTypeCode);
        break;
      }

      case Constants.NOTIFICATION_TYPE_MONITOR:
      {
        console.log('app.processNotification: call DisplayNotificationMonitorPage');
        this.DisplayNotificationMonitorPage(data.NotificationData, this.NotificationData.NotificationSourceCode, this.NotificationData.NotificationTypeCode);
        break;
      }

      case Constants.NOTIFICATION_TYPE_AMBITMESSAGE:
      {
        console.log('app.processNotification: call DisplayNotificationAmbitMessageModal');
        this.DisplayNotificationAmbitMessageModal(data.NotificationData, this.NotificationData.AmbitMessageId, this.NotificationData.NotificationSourceCode, this.NotificationData.NotificationTypeCode);
        break;
      }

      case Constants.NOTIFICATION_TYPE_EVENTNOTIFICATION:
      {
        console.log('app.processNotification: call DisplayNotificationEventNotificationModal');
        this.DisplayNotificationEventNotificationModal(data.NotificationData, this.NotificationData.AmbitMessageId, this.NotificationData.NotificationSourceCode, this.NotificationData.NotificationTypeCode);
        break;
      }

      default:
      {
        console.warn('app.processNotification: UNKNOWN');
        alert("app.processNotification:  unhandled NotificationType:" + this.NotificationData.NotificationTypeCode);
        break;
      }
    }
  }

  // ------------------------------------------------------------------------------

  DisplayNotificationSurveyModal(notificationData:NotificationData, SurveyBroadcastId:number, NotificationSourceCode:string, NotificationTypeCode:string)
  {
    // Check to see if we are already displaying this Survey Notification
    if (this.SurveyBroadcastId === SurveyBroadcastId)
    {
      console.log("app.DisplayNotificationSurveyModal - already showing SurveyBroadcastId:" + this.SurveyBroadcastId + " - this Source:" + NotificationSourceCode + " Type:" + NotificationTypeCode);
      return;
    }

    //  this is a new broadcast so save it as the recent displayed one and open the modal for it
    console.log("app.DisplayNotificationSurveyModal - DISPLAY new SurveyBroadcastId:" + SurveyBroadcastId + " - previous SurveyBroadcastId:" + this.SurveyBroadcastId + " - this Source:" + NotificationSourceCode + " Type:" + NotificationTypeCode);
    this.SurveyBroadcastId = SurveyBroadcastId;
    if (this.globalProvider.NavData.ModalSurveyBroadcastId === SurveyBroadcastId)
    {
      console.log("app.DisplayNotificationSurveyModal - FYI - we are already showing SurveyBroadcastId:" + SurveyBroadcastId + " - this Source:" + NotificationSourceCode + " Type:" + NotificationTypeCode);
      return;
    }
    
    let toastMessage:string = "Survey Notification";
    this.commonProvider.presentToast(toastMessage, SurveyBroadcastId.toString());
  
    //if (this.consoleLog) 
    console.log("app.DisplayNotificationSurveyModal - opening modal for SurveyBroadcastId:" + SurveyBroadcastId + " - this Source:" + NotificationSourceCode + " Type:" + NotificationTypeCode);
    this.openModalAttentionSurvey(notificationData, SurveyBroadcastId, NotificationSourceCode, NotificationTypeCode);
  }

  DisplayNotificationActionableModal(notificationData:NotificationData, ActionableBroadcastId:number, NotificationSourceCode:string, NotificationTypeCode:string)
  {
    // Check to see if we are already displaying this Survey Notification
    if (this.ActionableBroadcastId === ActionableBroadcastId)
    {
      console.log("app.DisplayNotificationActionableModal - already showing ActionableBroadcastId:" + this.ActionableBroadcastId + " - this Source:" + NotificationSourceCode + " Type:" + NotificationTypeCode);
      return;
    }

    //  this is a new broadcast so save it as the recent displayed one and open the modal for it
    console.log("app.DisplayNotificationActionableModal - DISPLAY new ActionableBroadcastId:" + ActionableBroadcastId + " - previous ActionableBroadcastId:" + this.ActionableBroadcastId + " - this Source:" + NotificationSourceCode + " Type:" + NotificationTypeCode);
    this.ActionableBroadcastId = ActionableBroadcastId;

    // otherwise this is a new broadcast so display it
    if (this.globalProvider.NavData.ModalActionableBroadcastId === ActionableBroadcastId)
    {
      console.log("app.DisplayNotificationActionableModal - FYI - we are already showing ActionableBroadcastId:" + ActionableBroadcastId + " - this Source:" + NotificationSourceCode + " Type:" + NotificationTypeCode);
      return;
    }
     
    let toastMessage:string = "Actionable Notification";
    this.commonProvider.presentToast(toastMessage, ActionableBroadcastId.toString());
  
    //if (this.consoleLog) 
    console.log("app.DisplayNotificationActionableModal - opening modal for ActionableBroadcastId:" + ActionableBroadcastId + " - this Source:" + NotificationSourceCode + " Type:" + NotificationTypeCode);
    this.openModalAttentionActionable(notificationData, ActionableBroadcastId, NotificationSourceCode, NotificationTypeCode);
  }

  DisplayNotificationEventNotificationModal(notificationData:NotificationData, AmbitMessageId:number, NotificationSourceCode:string, NotificationTypeCode:string)
  {
    // Check to see if we are already displaying this Survey Notification
    if (this.AmbitMessageId === AmbitMessageId)
    {
      console.log("app.DisplayNotificationEventNotificationModal - already showing AmbitMessageId:" + this.AmbitMessageId + " - this Source:" + NotificationSourceCode + " Type:" + NotificationTypeCode);
      return;
    }

    //  this is a new broadcast so save it as the recent displayed one and open the modal for it
    console.log("app.DisplayNotificationEventNotificationModal - DISPLAY new AmbitMessageId:" + AmbitMessageId + " - previous AmbitMessageId:" + this.AmbitMessageId + " - this Source:" + NotificationSourceCode + " Type:" + NotificationTypeCode);
    this.AmbitMessageId = AmbitMessageId;

    // otherwise this is a new broadcast so display it
    if (this.globalProvider.NavData.ModalAmbitMessageId === AmbitMessageId)
    {
      console.log("app.DisplayNotificationEventNotificationModal - FYI - we are already showing AmbitMessageId:" + AmbitMessageId + " - this Source:" + NotificationSourceCode + " Type:" + NotificationTypeCode);
      return;
    }
     
    let toastMessage:string = "Actionable Notification";
    this.commonProvider.presentToast(toastMessage, AmbitMessageId.toString());
  
    //if (this.consoleLog) 
    console.log("app.DisplayNotificationEventNotificationModal - opening modal for AmbitMessageId:" + AmbitMessageId + " - this Source:" + NotificationSourceCode + " Type:" + NotificationTypeCode);
    this.openModalNotificationEventNotification(notificationData, AmbitMessageId, NotificationSourceCode, NotificationTypeCode);
  }
  
  DisplayNotificationAmbitMessageModal(notificationData:NotificationData, AmbitMessageId:number, NotificationSourceCode:string, NotificationTypeCode:string)
  {
    // Check to see if we are already displaying this Survey Notification
    if (this.AmbitMessageId === AmbitMessageId)
    {
      console.log("app.DisplayNotificationAmbitMessageModal - already showing AmbitMessageId:" + this.AmbitMessageId + " - this Source:" + NotificationSourceCode + " Type:" + NotificationTypeCode);
      return;
    }

    //  this is a new broadcast so save it as the recent displayed one and open the modal for it
    console.log("app.DisplayNotificationAmbitMessageModal - DISPLAY new AmbitMessageId:" + AmbitMessageId + " - previous AmbitMessageId:" + this.AmbitMessageId + " - this Source:" + NotificationSourceCode + " Type:" + NotificationTypeCode);
    this.AmbitMessageId = AmbitMessageId;

    // otherwise this is a new broadcast so display it
    if (this.globalProvider.NavData.ModalAmbitMessageId === AmbitMessageId)
    {
      console.log("app.DisplayNotificationAmbitMessageModal - FYI - we are already showing AmbitMessageId:" + AmbitMessageId + " - this Source:" + NotificationSourceCode + " Type:" + NotificationTypeCode);
      return;
    }
     
    let toastMessage:string = "Actionable Notification";
    this.commonProvider.presentToast(toastMessage, AmbitMessageId.toString());
  
    //if (this.consoleLog) 
    console.log("app.DisplayNotificationAmbitMessageModal - opening modal for AmbitMessageId:" + AmbitMessageId + " - this Source:" + NotificationSourceCode + " Type:" + NotificationTypeCode);
    this.openModalNotificationAmbitMessage(notificationData, AmbitMessageId, NotificationSourceCode, NotificationTypeCode);
  }

  DisplayNotificationMonitorPage(notificationData:NotificationData, NotificationSourceCode:string, NotificationTypeCode:string)
  {
    // maybe it's just easier to navigate directly to the Monitor Page rather than as a modal
    // - as this will get complicated very quickly!

    let url = "/actions-monitor";
    console.log("app.DisplayNotificationMonitorPage: go to " + url);
    //this.router.navigateByUrl(url, { skipLocationChange: true });
    this.globalProvider.NavData.Initialize(this.pageName);
    this.globalProvider.NavData.IsNavDataExists = true;
    this.router.navigateByUrl(url);    //this.nav.setRoot(page.component);

    // NOTE:  IF WE ARE ALREADY ON THE MONITOR PAGE, THEN WE NEED TO TRIGGER THE INITIALIZE
    

    //this.nav.setRoot(ActionsMonitorPage);\
  }

  // ------------------------------------------------------------------------------

  async openModalAttentionSurvey(notificationData:NotificationData, SurveyBroadcastId:number, NotificationSourceCode:string, NotificationTypeCode:string) 
  {
    console.log("app.openModalAttentionSurvey - SurveyBroadcastId:" + SurveyBroadcastId + " - Source:" + NotificationSourceCode + " Type:" + NotificationTypeCode, notificationData);
    
    this.globalProvider.NavData.InitSurveyModal("app.openModalAttentionSurvey(" + NotificationSourceCode + ")");
    //this.globalProvider.NavData.IsNavDataExists = true;
    this.globalProvider.NavData.ModalSurveyFlag = true;
    this.globalProvider.NavData.ModalSurveyUrl = '/attention-survey-modal';     
    this.globalProvider.NavData.ModalSurveyBroadcastId = SurveyBroadcastId;   // e.g. SurveyId, SupportId, ReportId, etc.
    this.globalProvider.NavData.ModalSurveyNotificationSourceCode = NotificationSourceCode;   //
    
    //this.router.navigateByUrl(this.globalProvider.NavData.ModalUrl);

    const modal: HTMLIonModalElement =
       await this.modalController.create(
        { component: AttentionSurveyModalPage
        , componentProps:       // used as FYI only -- we now use the NavData fields I created above
          { SurveyBroadcastId: SurveyBroadcastId
          , item: null
          , isModal: "true" 
          }
        });
     
    modal.onDidDismiss().then((returnedData:any) => 
    {
      console.log("app.openModalAttentionSurvey - onDidDismiss", returnedData);
    });
    
    await modal.present();
  }

  async openModalAttentionActionable(notificationData:NotificationData, ActionableBroadcastId:number, NotificationSourceCode:string, NotificationTypeCode:string) 
  {
    console.log("app.openModalAttentionActionable - ActionableBroadcastId:" + ActionableBroadcastId + " - Source:" + NotificationSourceCode + " Type:" + NotificationTypeCode, notificationData);
    
    this.globalProvider.NavData.InitActionableModal("app.openModalAttentionActionable(" + NotificationSourceCode + ")");
    //this.globalProvider.NavData.IsNavDataExists = true;
    this.globalProvider.NavData.ModalActionableFlag = true;
    this.globalProvider.NavData.ModalActionableUrl = '/attention-actionable-modal';     
    this.globalProvider.NavData.ModalActionableBroadcastId= ActionableBroadcastId;   // e.g. SurveyId, SupportId, ReportId, etc.
    this.globalProvider.NavData.ModalActionableNotificationSourceCode = NotificationSourceCode;   //
    
    //this.router.navigateByUrl(this.globalProvider.NavData.ModalUrl);

    const modal: HTMLIonModalElement =
       await this.modalController.create(
        { component: AttentionActionableModalPage
        , componentProps:       // used as FYI only -- we now use the NavData fields I created above
          { ActionableBroadcastId: ActionableBroadcastId
          , item: null
          , isModal: "true" 
          }
        });
     
    modal.onDidDismiss().then((returnedData:any) => 
    {
      console.log("app.openModalAttentionActionable - onDidDismiss", returnedData);
    });
    
    await modal.present();
  }

  async openModalNotificationEventNotification(notificationData:NotificationData, AmbitMessageId:number, NotificationSourceCode:string, NotificationTypeCode:string) 
  {
    console.log("app.openModalNotificationEventNotification - AmbitMessageId:" + AmbitMessageId + " - Source:" + NotificationSourceCode + " Type:" + NotificationTypeCode, notificationData);
    
    let useAlertDialog:boolean = true;
    if (useAlertDialog === true)
    {
      console.warn("app.openModalNotificationAmbitMessage - AmbitMessageId:" + AmbitMessageId + " EVENTNOTIFICATION MODAL NOT DEVELOPED YET -- STICK WITH ALERT BOX FOR NOW");
      this.openGenericAlertDialog(notificationData);
      return;
    }

    this.globalProvider.NavData.InitActionableModal("app.openModalNotificationEventNotification(" + NotificationSourceCode + ")");
    //this.globalProvider.NavData.IsNavDataExists = true;
    this.globalProvider.NavData.ModalAmbitMessageFlag = true;
    this.globalProvider.NavData.ModalAmbitMessageUrl = '/eventnotification-modal';     
    this.globalProvider.NavData.ModalAmbitMessageId= AmbitMessageId;   // e.g. SurveyId, SupportId, ReportId, etc.
    this.globalProvider.NavData.ModalActionableNotificationSourceCode = NotificationSourceCode;   //
    //this.router.navigateByUrl(this.globalProvider.NavData.ModalUrl);

    const modal: HTMLIonModalElement =
       await this.modalController.create(
        { component: AttentionActionableModalPage   // ToDo:  CHANGE THIS TO A NEW AMBIT MESSAGE /EVENT NOTIFICATION PAGE
        , componentProps:       // used as FYI only -- we now use the NavData fields I created above
          { AmbitMessageId: AmbitMessageId
          , item: null
          , isModal: "true" 
          }
        });
     
    modal.onDidDismiss().then((returnedData:any) => 
    {
      console.log("app.openModalNotificationAmbitMessage - onDidDismiss", returnedData);
    });
    
    await modal.present();
  }

  async openModalNotificationAmbitMessage(notificationData:NotificationData, AmbitMessageId:number, NotificationSourceCode:string, NotificationTypeCode:string) 
  {
    console.log("app.openModalNotificationAmbitMessage - AmbitMessageId:" + AmbitMessageId + " - Source:" + NotificationSourceCode + " Type:" + NotificationTypeCode, notificationData);
    
    let useAlertDialog:boolean = true;
    if (useAlertDialog === true)
    {
      console.warn("app.openModalNotificationAmbitMessage - AmbitMessageId:" + AmbitMessageId + " AMBITMESSAGE MODAL NOT DEVELOPED YET -- STICK WITH ALERT BOX FOR NOW");
      this.openGenericAlertDialog(notificationData);
      return;
    }

    this.globalProvider.NavData.InitActionableModal("app.openModalNotificationAmbitMessage(" + NotificationSourceCode + ")");
    //this.globalProvider.NavData.IsNavDataExists = true;
    this.globalProvider.NavData.ModalAmbitMessageFlag = true;
    this.globalProvider.NavData.ModalAmbitMessageUrl = '/eventnotification-modal';     
    this.globalProvider.NavData.ModalAmbitMessageId= AmbitMessageId;   // e.g. SurveyId, SupportId, ReportId, etc.
    this.globalProvider.NavData.ModalActionableNotificationSourceCode = NotificationSourceCode;   //
    //this.router.navigateByUrl(this.globalProvider.NavData.ModalUrl);

    const modal: HTMLIonModalElement =
       await this.modalController.create(
        { component: AttentionActionableModalPage   // ToDo:  CHANGE THIS TO A NEW AMBIT MESSAGE /EVENT NOTIFICATION PAGE
        , componentProps:       // used as FYI only -- we now use the NavData fields I created above
          { AmbitMessageId: AmbitMessageId
          , item: null
          , isModal: "true" 
          }
        });
     
    modal.onDidDismiss().then((returnedData:any) => 
    {
      console.log("app.openModalNotificationAmbitMessage - onDidDismiss", returnedData);
    });
    
    await modal.present();
  }

  myTranslate(value:string):string
  {
    // WARNING! inline translation will CRASH if the value is empty
    if (!value) { return ""; }
    return this.translate.instant(value);
  }

  // use this in lieu of a Modal display (e.g. Ambit Message and Event Notification)
  async openGenericAlertDialog(notificationData:NotificationData)
  {
    if (this.consoleLog) console.log("app.openGenericAlertDialog", notificationData);

    const alert = await this.alertController.create(
      { header: this.myTranslate(notificationData.MessageTitle)
      , subHeader: this.myTranslate(notificationData.MessageSubTitle)
      , message: this.myTranslate(notificationData.MessageText) 
                 + " (ID:" + notificationData.AmbitMessageId + ")"
      , buttons: [
        {
          text: this.myTranslate('OK'),
          handler: () => {
            console.log('app.openGenericAlertDialog - OK');
            return;
          }
        }
      ]
    });
    await alert.present();
  }

  // ------------------------------------------------------------------------------

  // ----------------------------------------------------
  // ------ GET DASHBOARD EVENT COUNTS ON STARTUP -------
  // ----------------------------------------------------
  CallGetDashboardStatusForMobile(context:string, isCheckUnseenNotificationss:boolean)
  {
    if (!this.globalProvider.MobileUserProfile.ActiveLogin) { return; }

    if (this.consoleLog) console.log("app.CallGetDashboardStatusForMobile - " + context);
    this.notificationProvider.CallGetDashboardStatusForMobile("app." + context, isCheckUnseenNotificationss);

    // NOTE:  
    // check for unseen surveys or actionable forms?
  }

  VerifyPushRegistration()
  {
    if (this.globalProvider.PushConfig.IsRegisteredWithAmbit())
    {
      return;  // nothing to do as already registerered (may want to force daily check)
    }

    if (this.globalProvider.MobileUserProfile.ActiveLogin)
    {
      //FIREBASE-YO: this.pushfirebase.InitializeProvider("[app.VerifyPush]");
      this.pushphonegap.InitializeProvider("[app.VerifyPush]");
    }
  }
}
